import { useLocation } from 'react-router';
import type { GroupId, GroupMemberInvitationId } from 'balus-common';
import { Layout } from './Layout';
import { ErrorMessage } from './ErrorMessage';
import { PageContent } from './PageContent';
import { readStashedInvitationToken } from './invitationToken';

type QueryParam = {
  groupId: GroupId | null;
  invitationId: GroupMemberInvitationId | null;
  token: string | null;
};

const useQueryParams = (): QueryParam => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const invitationId = params.get('invitationId');

  return {
    groupId: params.get('groupId'),
    invitationId,
    token: params.get('token') ?? (invitationId ? readStashedInvitationToken(invitationId) : null),
  };
};

/**
 * グループメンバーへの招待情報を表示するページ
 */
export const GroupMemberInvitationPage: React.FC<unknown> = () => {
  const { groupId, invitationId, token } = useQueryParams();

  return (
    <Layout>
      {!groupId || !invitationId ? (
        <ErrorMessage errorReason="notFound" />
      ) : (
        <PageContent groupId={groupId} invitationId={invitationId} token={token} />
      )}
    </Layout>
  );
};
